import { css } from '@emotion/react';
import { ColorPalette } from './ColorPalette';
import Spinner from './Spinner';

interface LoadingViewProps {
  text?: string;
}

export default function LoadingView({ text = 'Loading...' }: LoadingViewProps) {
  return (
    <div css={styles.container}>
      <Spinner />
      <span css={styles.text}>{text}</span>
    </div>
  );
}

const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 24,
  }),
  text: css({
    color: ColorPalette.normalText,
    fontSize: 14,
  }),
};
